import React from 'react'
import profile from '../../../../images/profile/profile.png';
import StudentHeader from '../../StudentHeader';

const ESchool = () => {
    return (
        <>
            <StudentHeader />

            <div className='container'>
                <div className="card card-primary my-5">


                    <div className="card-body" style={{ background: "#EFEFEF", height: "", padding: "0" }}>
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <div className='row' style={{ padding: "20px", margin: "10px", background: "#fff", borderRadius: "5px" }}>
                                    <div className='col-12'>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Sunday</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left", }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>10:00 AM - 11:00 AM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Subject : English</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Class : Seven</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Section : A</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Teacher Initial : AKM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h5 className='' style={{ textAlign: "left", color: '#00CC99' }}>Link : <span style={{ color: 'tomato' }}>Meet link/Zoom Link</span></h5>

                                        </div>


                                    </div>

                                </div>
                            </div>
                            <div className='col-12 text-center'>
                                <div className='row' style={{ padding: "20px", margin: "10px", background: "#fff", borderRadius: "5px" }}>
                                    <div className='col-12'>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Sunday</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left", }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>10:00 AM - 11:00 AM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Subject : English</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Class : Seven</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Section : A</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Teacher Initial : AKM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h5 className='' style={{ textAlign: "left", color: '#00CC99' }}>Link : <span style={{ color: 'tomato' }}>Meet link/Zoom Link</span></h5>

                                        </div>


                                    </div>

                                </div>
                            </div>
                            <div className='col-12 text-center'>
                                <div className='row' style={{ padding: "20px", margin: "10px", background: "#fff", borderRadius: "5px" }}>
                                    <div className='col-12'>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Sunday</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left", }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>10:00 AM - 11:00 AM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Subject : English</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Class : Seven</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Section : A</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Teacher Initial : AKM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h5 className='' style={{ textAlign: "left", color: '#00CC99' }}>Link : <span style={{ color: 'tomato' }}>Meet link/Zoom Link</span></h5>

                                        </div>


                                    </div>

                                </div>
                            </div>
                            <div className='col-12 text-center'>
                                <div className='row' style={{ padding: "20px", margin: "10px", background: "#fff", borderRadius: "5px" }}>
                                    <div className='col-12'>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Sunday</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left", }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>10:00 AM - 11:00 AM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Subject : English</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Class : Seven</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Section : A</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Teacher Initial : AKM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h5 className='' style={{ textAlign: "left", color: '#00CC99' }}>Link : <span style={{ color: 'tomato' }}>Meet link/Zoom Link</span></h5>

                                        </div>


                                    </div>

                                </div>
                            </div>
                            <div className='col-12 text-center'>
                                <div className='row' style={{ padding: "20px", margin: "10px", background: "#fff", borderRadius: "5px" }}>
                                    <div className='col-12'>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Sunday</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left", }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>10:00 AM - 11:00 AM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Subject : English</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Class : Seven</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Section : A</h6>
                                            <h5 className='mx-2 text-warning' style={{ textAlign: "left" }}> || </h5>
                                            <h6 className='' style={{ textAlign: "left", color: '#00CC99' }}>Teacher Initial : AKM</h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <h5 className='' style={{ textAlign: "left", color: '#00CC99' }}>Link : <span style={{ color: 'tomato' }}>Meet link/Zoom Link</span></h5>

                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ESchool